import React, {Component} from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Avatar, Backdrop, Block, Divider, Overlay, Portal, Tabs} from "reakit";
import {Box, Flex, Heading, Image, Link, Text} from 'rebass';
import {HeaderWrapper} from "../Base/MobileHeader";
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import chevronRight from "../../resources/img/icons/Chevron_2@1x.png";

const FilterOverlay = styled(Overlay)`

		width: 50%;
		max-width: 600px;
 		height: 70%;
 @media(max-width: 700px){
 		width: 100%;
		height: 100%;
 }
`

const StyledLink = styled(Link)`
 text-decoration: none;
`

class Parents extends Component {

	state = {
		gender: '',
		grade: '',
		dorm: '',
		location: '',
		type: ''
	};

	handleSelect = () => {
		console.log('select')
	};

	render() {
		const {profile, parents} = this.props;
		let parent1;
		let parent2;
		if (parents.length > 1) {
			parent1 = parents[0];
			parent2 = parents[1];
		}
		else if (parents.length > 0) {
			parent1 = parents[0];
		}
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex onClick={overlay.show} {...overlay} width={1}>
							<Box><Text fontWeight={600}>Parents</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} margin={0} padding={0}>
							{overlay.visible &&
							<Box>
									<Tabs.Container>
										{tabs => (
											<Block>
												<Tabs width={'100%'}>
													<HeaderWrapper boxShadow={'main'} pt={2} px={2} width={1}>
														<Box mt={2}>
															<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>
														</Box>
														<Heading pl={2}>{profile.first_name}'s Parents</Heading>
														{parent1 != null && <Tabs.Tab tab="mom" {...tabs}>Parent 1</Tabs.Tab>}
														{parent2 != null && <Tabs.Tab tab="dad" {...tabs}>Parent 2</Tabs.Tab>}
													</HeaderWrapper>

												</Tabs>
												{parent1 != null && 
													<Tabs.Panel tab="mom" {...tabs}>
															<Box key={parent1.id} pt={3}>
																<Flex flexWrap={'wrap'} p={1} mt={1} px={2}>
																	<Box width={1}>
																		<Flex>
																			<Box>
																				<Heading as={'h5'}>{parent1.first_name} {parent1.last_name}</Heading>
																			</Box>
																			<Box ml={'auto'}/>
																			<Box>
																				<Avatar src={parent1.profile_pic} width={'70px'} height={'70px'}
																						backgroundColor={'#707070'}/>
																			</Box>
																		</Flex>
																	</Box>

																	<Box width={1} py={1}/>

																	<Flex width={1} py={3}>
																		<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'}
																								fontWeight={600}>Email</Text></Box>
																		<Box ml={'auto'}/>
																		<Box><Text color='#969a9b' fontSize={'16px'}
																				fontWeight={600}>{parent1.email}</Text></Box>
																	</Flex>

																	<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>


																	<Flex width={1} py={3}>
																		<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'}
																								fontWeight={600}>Mobile</Text></Box>
																		<Box ml={'auto'}/>
																		<Box>
																			{parent1.mobile != null &&
																			<Box><StyledLink href={`tel:${parent1.mobile.split('-').join('')}`} color='#969a9b' fontSize={'16px'} fontWeight={600}>{parent1.mobile}</StyledLink></Box>
																			}
																		</Box>
																	</Flex>

																</Flex>


															</Box>
													</Tabs.Panel>
												}
												{parent2 != null &&
													<Tabs.Panel tab="dad" {...tabs}>
															<Box key={parent2.id} pt={3}>

																<Flex flexWrap={'wrap'} p={1} mt={1} px={2}>
																	<Box width={1}>
																		<Flex>
																			<Box>
																				<Heading as={'h5'}>{parent2.first_name} {parent2.last_name}</Heading>
																			</Box>
																			<Box ml={'auto'}/>
																			<Box>
																				<Avatar src={parent2.profile_pic} width={'70px'} height={'70px'}
																						backgroundColor={'#707070'}/>
																			</Box>
																		</Flex>
																	</Box>

																	<Box width={1} py={1}/>

																	<Flex width={1} py={3}>
																		<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'}
																								fontWeight={600}>Email</Text></Box>
																		<Box ml={'auto'}/>
																		<Box><Text color='#969a9b' fontSize={'16px'}
																				fontWeight={600}>{parent2.email}</Text></Box>
																	</Flex>

																	<Box width={1} py={1}><Divider padding={0} margin={0}/></Box>


																	<Flex width={1} py={3}>
																		<Box width={1 / 2}><Text marginTop='7px' fontSize={'16px'}
																								fontWeight={600}>Mobile</Text></Box>
																		<Box ml={'auto'}/>
																		<Box>
																			{parent2.mobile != null &&
																			<Box><StyledLink href={`tel:${parent2.mobile.split('-').join('')}`} color='#969a9b' fontSize={'16px'} fontWeight={600}>{parent2.mobile}</StyledLink></Box>
																			}
																		</Box>
																	</Flex>
																</Flex>
															</Box>
													</Tabs.Panel>
												}
											</Block>
										)}
									</Tabs.Container>
								

							</Box>
							}
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

Parents.propTypes = {
	profile: PropTypes.object
};

Parents.defaultProps = {
	profile: {first_name: '', last_name: ''}
};


export default Parents
